var _rect, _path, _path2, _circle, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuickTransfer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 0.8,
    width: 34.4,
    height: 34.4,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9089 14.5953C10.9089 16.4406 11.656 18.2103 12.9859 19.5151C14.3158 20.8199 16.1196 21.553 18.0004 21.553C19.8811 21.553 21.6849 20.8199 23.0148 19.5151C24.3447 18.2103 25.0918 16.4406 25.0918 14.5953L18.0004 14.5953L10.9089 14.5953Z",
    fill: "#FF7576"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4842 23.3678C10.4842 25.3235 11.276 27.199 12.6855 28.5819C14.0949 29.9648 16.0066 30.7417 17.9999 30.7417C19.9932 30.7417 21.9048 29.9648 23.3143 28.5819C24.7238 27.199 25.5156 25.3235 25.5156 23.3678L17.9999 23.3678L10.4842 23.3678Z",
    fill: "#FF7576"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 9.24928,
    r: 3.44923,
    fill: "#FF7576"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 0.8,
    width: 34.4,
    height: 34.4,
    rx: 5,
    stroke: "#B7B7B7",
    strokeWidth: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickTransfer);
export default __webpack_public_path__ + "static/media/QuickTransfer.97f79abde786a48b1ab323ee3cacbe2b.svg";
export { ForwardRef as ReactComponent };